import { render, staticRenderFns } from "./SearchPage.vue?vue&type=template&id=b412c900&scoped=true&"
import script from "./SearchPage.vue?vue&type=script&lang=js&"
export * from "./SearchPage.vue?vue&type=script&lang=js&"
import style0 from "./SearchPage.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SearchPage.vue?vue&type=style&index=1&id=b412c900&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b412c900",
  null
  
)

export default component.exports